import React, { useEffect } from "react";
import Header from "../../components/partials/header";
import Sidebar from "../../components/partials/sidebar";
import { motion } from "framer-motion";
import Footer from "../../components/partials/footer";
import ThemeCustomize from "../../components/partials/customizer/theme-customizer";
import MobileSidebar from "../../components/partials/sidebar/mobile-sidebar";
import HeaderSearch from "../../components/header-search";
import LayoutLoader from "../../components/layout-loader";
import { cn } from "../../helper/utilityHelper";
import { useSidebar, useThemeStore } from "../../store";
import { useMediaQuery, useMounted } from "../../hooks";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/auth/authContext";
const MainLayout = ({ children }) => {
  const { collapsed, sidebarType, subMenu } = useSidebar();
  const [open, setOpen] = React.useState(false);
  const { layout } = useThemeStore();
  const location = useLocation();
  const pathName = location.pathname;
  const isMobile = useMediaQuery("(min-width: 768px)");
  const mounted = useMounted();
  const { isLoading, routesReady } = useAuth();

  useEffect(() => {
    // global.log("location changed", location.pathname);
  }, [location]);

  if (!mounted || isLoading || !routesReady) {
    return <LayoutLoader />;
  }

  if (layout === "semibox") {
    return (
      <>
        <Header handleOpenSearch={() => setOpen(true)} />
        <Sidebar />

        <div
          className={cn("content-wrapper transition-all duration-150 ", {
            "xl:ml-[72px]": collapsed,
            "xl:ml-[272px]": !collapsed,
          })}
        >
          <div
            className={cn(
              "  md:pt-6 pb-[37px] pt-[15px] md:px-6 px-4  page-min-height-semibox ",
              {}
            )}
          >
            <div className="xl:mx-14">
              <LayoutWrapper
                isMobile={isMobile}
                setOpen={setOpen}
                open={open}
                location={pathName}
              >
                {children}
                <Outlet />
              </LayoutWrapper>
            </div>
          </div>
        </div>
        <Footer />
        <ThemeCustomize />
      </>
    );
  }
  if (layout === "horizontal") {
    return (
      <>
        <Header handleOpenSearch={() => setOpen(true)} />

        <div className={cn("content-wrapper transition-all duration-150 ")}>
          <div
            className={cn(
              "  md:pt-6 pb-[37px] pt-[15px] md:px-6 px-4  page-min-height-horizontal ",
              {}
            )}
          >
            <LayoutWrapper
              isMobile={isMobile}
              setOpen={setOpen}
              open={open}
              location={pathName}
            >
              {children}
              <Outlet />
            </LayoutWrapper>
          </div>
        </div>
        <Footer />
        <ThemeCustomize />
      </>
    );
  }

  if (sidebarType !== "module") {
    return (
      <>
        <Header handleOpenSearch={() => setOpen(true)} />
        <Sidebar />

        <div
          className={cn("content-wrapper transition-all duration-150 ", {
            "xl:ml-[248px]": !collapsed,
            "xl:ml-[72px]": collapsed,
          })}
        >
          <div
            className={cn(
              "  md:pt-3 pb-[25px] pt-[15px] md:px-3 px-3  page-min-height ",
              {}
            )}
          >
            <LayoutWrapper
              isMobile={isMobile}
              setOpen={setOpen}
              open={open}
              location={pathName}
            >
              {children}
              <Outlet />
            </LayoutWrapper>
          </div>
        </div>
        <Footer />
        {/* <ThemeCustomize /> */}
      </>
    );
  }
  return (
    <>
      <Header handleOpenSearch={() => setOpen(true)} />
      <Sidebar />

      <div
        className={cn("content-wrapper transition-all duration-150 ", {
          "xl:ml-[300px]": !collapsed,
          "xl:ml-[72px]": collapsed,
        })}
      >
        <div
          className={cn(
            "md:pt-6 md:pb-[37px] pb-28 pt-[15px] md:px-6 px-4  page-min-height ",
            {}
          )}
        >
          <LayoutWrapper
            isMobile={isMobile}
            setOpen={setOpen}
            open={open}
            location={pathName}
          >
            {children}
            <Outlet />
          </LayoutWrapper>
        </div>
      </div>
      <Footer handleOpenSearch={() => setOpen(true)} />
      {isMobile && <ThemeCustomize />}
      <div id="detail">
        <Outlet />
      </div>
    </>
  );
};

export default MainLayout;

const LayoutWrapper = ({ children, isMobile, setOpen, open, location }) => {
  return (
    <>
      <motion.div
        key={location}
        initial="pageInitial"
        animate="pageAnimate"
        exit="pageExit"
        variants={{
          pageInitial: {
            opacity: 0,
            y: 50,
          },
          pageAnimate: {
            opacity: 1,
            y: 0,
          },
          pageExit: {
            opacity: 0,
            y: -50,
          },
        }}
        transition={{
          type: "tween",
          ease: "easeInOut",
          duration: 0.5,
        }}
      >
        <main>{children}</main>
      </motion.div>

      <MobileSidebar className="left-[300px]" />
      <HeaderSearch open={open} setOpen={setOpen} />
    </>
  );
};
